import { OPEN_INTERCOM_CHAT, CLOSE_INTERCOM_CHAT } from './types';

export const doOpenIntercomChat = () => ({
  type: OPEN_INTERCOM_CHAT
});

export const doCloseIntercomChat = () => ({
  type: CLOSE_INTERCOM_CHAT
});
